'use strict';

const Enum = require('./enum');

const FullEvents = {
  BRIDGE_CREATED: { value: 'bridge_created' },
  BRIDGE_DELETED: { value: 'bridge_deleted' },
  BRIDGE_REBOOT_ALL: { value: 'bridge_reboot_all', route: 'event.reboot.all.bridges' },
  BRIDGE_REBOOT_ONE: { value: 'bridge_reboot_one', route: 'event.reboot.one.bridge' },
  BRIDGE_STATUS_UPDATE: { value: 'bridge_status_update', route: 'event.update.status.bridge' },
  BRIDGE_OFFLINE: { value: 'bridge_offline', route: 'event.offline.bridge' },
  LOCK_STATUS_REPORTED: { value: 'lock_status_reported', route: 'event.update.remote.status.lock' },
  LOCK_CREATED: { value: 'lock_created', route: 'event.create.lock' },
  LOCK_DELETED: { value: 'lock_deleted', route: 'event.delete.lock' },
  LOCK_STATUS_CHANGED: { value: 'lock_status_changed', route: 'event.update.status.lock' },
  LOCK_USAGE_REPORTED: { value: 'lock_usage_reported', route: 'event.operate.ble.lock' },
  LOCK_OPERATION_REPORTED: { value: 'lock_operation_reported', route: 'event.operate.logs.lock' },
  LOCK_OPERATION_TYPE_REPORTED: { value: 'lock_operation_type_reported', route: 'event.operate-type.logs.lock' },
  LOCK_NAME_CHANGED: { value: 'lock_name_changed', route: 'event.update.name.lock' },
  LOCK_BATTERY_ALERT: { value: 'lock_battery_alert', route: 'event.alert.batterylevel.lock' },
  LOCK_USER_ADD: { value: 'lock_user_add', route: 'event.add.user.lock' },
  LOCK_USER_REMOVE: { value: 'lock_user_remove', route: 'event.delete.user.lock' },
  LOCK_USERTYPE_CHANGED: { value: 'lock_usertype_changed', route: 'event.update.usertype.lock' },
  LOCK_ACCESSTYPE_CHANGED: { value: 'lock_accesstype_changed', route: 'event.update.accesstype.lock' },
  LOCK_INTEGRATION_ACCESS: { value: 'lock_integration_access', route: 'event.update.integration.access.lock' },
  LOCK_INTEGRATION_ACCESS_REMINDER: {
    value: 'lock_integration_access_reminder',
    route: 'event.update.integration.reminder.lock',
  },
  LOCK_INTEGRATION_ACCESS_REMINDER_CREATE_BATCHES: {
    value: 'lock_integration_access_reminder_create_batches',
    route: 'event.update.integration.reminder.lock.create.batches',
  },
  LOCK_DOORBELL_BUTTONPRESS: { value: 'lock_doorbell_buttonpress', route: 'event.press.button.lockDoorbell' },
  LOCK_LINKED_CONNECT: { value: 'lock_linked_connect', route: 'event.connect.linked.lock' },
  LOCK_LOG_TIMESTAMP_DRIFTED: { value: 'lock_log_timestamp_drifted', route: 'event.log.timestamp.drifted.lock' },
  LINKED_OPERATION: { value: 'linked_operation', route: 'event.operate.linked' },
  REMOTE_OPERATION_REPORTED: { value: 'remote_operation_reported', route: 'event.operate.remote.lock' },
  TAMPERED_OPERATION_REPORTED: { value: 'tampered_operation_reported', route: 'event.operate.tampered.lock' },
  USER_ADDED: { value: 'user_added' },
  USER_CREATED: { value: 'user_created' },
  USER_DELETED: { value: 'user_deleted', route: 'event.delete.user' },
  USER_PARTNER_UNLINK: { value: 'user_partner_unlink', route: 'event.unlink.user' },
  HOUSE_ADDED: { value: 'house_added', route: 'event.create.house' },
  DEVICE_ADDED: { value: 'device_added', route: device => `event.create.${device}` },
  DEVICE_REMOVED: { value: 'device_removed', route: device => `event.delete.${device}` },
  EMAIL_VALIDATION_REQUESTED: { value: 'email_validation_requested' },
  PHONE_VALIDATION_REQUESTED: { value: 'phone_validation_requested' },
  CAMERA_STANDBY: { value: 'camera_standby', route: 'event.standby.camera' },
  DOORBELL_LEAVE_CALL: { value: 'leave', route: 'event.leave.call.doorbell' },
  DOORBELL_JOIN_CALL: { value: 'join', route: 'event.join.call.doorbell' },
  DOORBELL_QUICKCONNECT: { value: 'quickconnect', route: 'event.quickconnect.doorbell' },
  DOORBELL_IMAGECAPTURE: { value: 'imagecapture', route: 'event.capture.image.doorbell' },
  DOORBELL_MOTION_DETECTED: { value: 'doorbell_motion_detected', route: 'event.detect.motion.doorbell' },
  DOORBELL_BACK_ONLINE: { value: 'doorbell_back_online', route: 'event.online.doorbell' },
  DOORBELL_BUTTONPUSH: { value: 'buttonpush', route: 'event.push.button.doorbell' },
  DOORBELL_INITIATE: { value: 'initiate', route: 'event.initiate.doorbell' },
  DOORBELL_RESPOND: { value: 'respond', route: 'event.respond.doorbell' },
  DOORBELL_HANGUP: { value: 'hangup', route: 'event.hangup.doorbell' },
  DOORBELL_HEARTBEAT: { value: 'heartbeat', route: 'event.heartbeat.doorbell' },
  DOORBELL_CALL_HANGUP: { value: 'doorbell_call_hangup', route: 'event.hangup.call.doorbell' },
  DOORBELL_CALL_MISSED: { value: 'doorbell_call_missed', route: 'event.miss.call.doorbell' },
  DOORBELL_CALL_DECLINED: { value: 'doorbell_call_declined', route: 'event.decline.call.doorbell' },
  DOORBELL_CALL_ANSWERED: { value: 'doorbell_call_answered', route: 'event.answer.call.doorbell' },
  DOORBELL_CALL_ANSWERED_DUPLICATE: {
    value: 'doorbell_call_answered_duplicate',
    route: 'event.answer.duplicate.call.doorbell',
  },
  DOORBELL_CALL_INITIATED: { value: 'doorbell_call_initiated', route: 'event.initiate.call.doorbell' },
  DOORBELL_STATUS_ONLINE: { value: 'doorbell_call_status_online', route: 'event.online.doorbell' },
  DOORBELL_LOW_BATTERY: { value: 'doorbell_low_battery', route: 'event.alert.batterylevel.doorbell' },
  DOORBELL_SETTINGS_CHANGED: { value: 'doorbell_settings_changed', route: 'event.update.settings.doorbell' },
  DOORBELL_CHIME_SETTINGS_CHANGED: { value: 'chime_settings_changed', route: 'event.update.chime.settings.doorbell' },
  DOORBELL_FACTORY_RESET: { value: 'doorbell_factory_reset', route: 'event.delete.doorbell' },
  DOORBELL_SETUP_TERMINATE_SUBSCRIPTION: {
    value: 'doorbell_setup_terminate_subscription',
    route: 'event.create.doorbell.terminateSubscription',
  },
  DOORBELL_REBOOT: { value: 'doorbell_reboot', route: 'event.reboot.doorbell' },
  DOORBELL_WAKEUP: { value: 'doorbell_wakeup', route: 'event.wakeup.doorbell' },
  DOORBELL_DEPROVISION: { value: 'doorbell_deprovision', route: 'event.deprovision.doorbell' },
  DOORBELL_PING: { value: 'pinging_doorbell', route: 'event.ping.doorbell' },
  DOORBELL_OFFLINE: { value: 'doorbell_offline', route: 'event.offline.doorbell' },
  DOORBELL_NAME_CHANGE: { value: 'doorbell_name_change', route: 'event.update.name.doorbell' },
  DOORBELL_CALL_LOG_INSERTED: { value: 'doorbell call log inserted' },
  DOORBELL_CALL_LOG_POST_RECEIVED_FROM_DOORBELL: { value: 'doorbell POST request with image sent to mars server' },
  DOORBELL_CALL_LOG_REDIS_CALL_RECORD_INSERTED: { value: 'call record inserted into redis' },
  DOORBELL_CALL_LOG_REDIS_CALLSTATS_RECORD_INSERTED: { value: 'call stats record inserted into redis' },
  DOORBELL_CALL_LOG_MESSAGE_QUEUED_TO_EVENT_PROCESSOR: { value: 'message queued from mars api to event processor' },
  DOORBELL_CALL_LOG_IMAGE_MESSAGE_QUEUED_TO_EVENT_PROCESSOR: {
    value: 'image message queued from mars api to event processor',
  },
  DOORBELL_CALL_LOG_IMAGE_UPLOADED: { value: 'uploaded doorbell image to cloud' },
  DOORBELL_CALL_LOG_IMAGE_UPDATED_IN_REDIS: { value: 'updated redis record with image' },
  DOORBELL_CALL_LOG_IMAGE_UPDATED_IN_DB: { value: 'updated db recent image record' },
  DOORBELL_CALL_LOG_BUTTONPRESS_PUBNUB_MESSAGE_QUEUED_TO_EVENT_PROCESSOR: {
    value: 'pubnub message queued from event processor to notification server',
  },
  DOORBELL_CALL_LOG_BUTTONPRESS_PUSH_NOTIFICATION_MESSAGE_QUEUED_TO_EVENT_PROCESSOR: {
    value: 'push notification message queued from event processor to notification server',
  },
  DOORBELL_CALL_LOG_BUTTONPRESS_PUBNUB_SENT: { value: 'sent buttonpress pubnub' },
  DOORBELL_CALL_LOG_IMAGECAPTURE_PUBNUB_MESSAGE_QUEUED_TO_EVENT_PROCESSOR: { value: 'sent imagecapture pubnub' },
  DOORBELL_CALL_LOG_IMAGECAPTURE_PUBNUB_SENT: { value: 'sent imagecapture pubnub' },
  DOORBELL_CALL_LOG_BUTTONPRESS_PUSH_NOTIFICATION_SENT: { value: 'sent buttonpress push notification' },
  DOORBELL_CALL_LOG_RESPOND: { value: 'doorbell call answered' },
  DOORBELL_CALL_LOG_DECLINE: { value: 'doorbell call declined' },
  DOORBELL_CALL_LOG_EXPIRE: { value: 'doorbell call expired' },
  DOORBELL_CALL_LOG_HANGUP: { value: 'doorbell call hung up' },
  DOORBELL_CALL_LOG_NOTIFICATION_UPDATED: { value: 'updated quick connect parameters' },
  DOORBELL_VIDEO_ENCODING_REQUESTED: {
    value: 'doorbell_video_encoding_requested',
    route: 'event.encode.request.video.doorbell',
  },
  DOORBELL_VIDEO_ENCODING_STARTED: {
    value: 'doorbell_video_encoding_started',
    route: 'event.encode.start.video.doorbell',
  },
  DOORBELL_VIDEO_ENCODING_IN_PROGRESS: {
    value: 'doorbell_video_encoding_in_progress',
    route: 'event.encode.inprogress.video.doorbell',
  },
  DOORBELL_VIDEO_ENCODING_FAILED: { value: 'doorbell_video_encoding_failed' },
  DOORBELL_VIDEO_READY: { value: 'doorbell_video_ready', route: 'event.encode.done.video.doorbell' },
  DOORBELL_VIDEO_UPLOAD_AVAILABLE: {
    value: 'doorbell_video_upload_available',
    route: 'event.upload_available.video.doorbell',
  },
  DOORBELL_VIDEO_TEASER_PLAYLIST_REQUESTED: {
    value: 'doorbell_video_teaser_playlist_requested',
    route: 'm3u.create.playlist.teaser',
  },
  DOORBELL_UPLOAD_VIDEO: { value: 'doorbell_upload_video', route: 'event.uploadvideo.doorbell' },
  SHARE_WITH_AUGUST: { value: 'dvr_video_share_with_august', route: device => `event.sharewithaugust.${device}` },
  PIN_TRANSACTION_ISSUED: { value: 'pin_transaction_issued' },
  PIN_TRANSACTION_COMPLETED: { value: 'pin_transaction_completed' },
  DOORBELL_OTA_UPDATE_INITIATE: { value: 'ota_update_initiate', route: 'event.initiate.ota.doorbell' },
  DOORBELL_OTA_UPDATE_PROGRESS: { value: 'ota_update_progress', route: 'event.progress.ota.doorbell' },
  DOORBELL_OTA_UPDATE_FAILED: { value: 'ota_update_failed' },
  DOORBELL_OTA_START: { value: 'doorbell_ota_start', route: 'event.start.ota.doorbell' },
  AIRBNB_HOST_ONBOARDING: { value: 'airbnb_host_onboarding' },
  AIRBNB_HOST_REMINDER_GUEST_NO_KEY: { value: 'airbnb_host_reminder_guest_no_key' },
  AIRBNB_DISCONNECT: { value: 'airbnb_disconnect' },
  GOOGLE_TOO_MANY_FAILED_PIN_ATTEMPTS: {
    value: 'google_too_many_failed_pin_attempts',
    route: 'event.notify.restricted.unlock.google',
  },
  KEYPAD_BATTERY_CRITICAL: { value: 'keypad_battery_critical' },
  KEYPAD_BATTERY_WARNING: { value: 'keypad_battery_warning' },
  KEYPAD_BATTERY_NONE: { value: 'keypad_battery_none' },
  KEYPAD_DELETED: { value: 'keypad_deleted', route: 'event.delete.keypad' },
  KEYPAD_LOCK: { value: 'keypad_lock', route: 'event.operate.keypad' },
  KEYPAD_UNLOCK: { value: 'keypad_unlock', route: 'event.operate.keypad' },
  KEYPAD_ONETOUCH_LOCK: { value: 'keypad_onetouch_lock', route: 'event.operate.keypad' },
  KEYPAD_WRONG_CODE: { value: 'keypad_wrong_code', route: 'event.operate.keypad' },
  KEYPAD_PIN_MANAGED: { value: 'keypad_pin_managed', route: 'event.pin.managed.keypad' },
  DOORPOSITIONSENSOR_BATTERY_CRITICAL: {
    value: 'dps_battery_critical',
    route: 'event.alert.batterylevel.doorpositionsensor',
  },
  DOORPOSITIONSENSOR_BATTERY_WARNING: {
    value: 'dps_battery_warning',
    route: 'event.alert.batterylevel.doorpositionsensor',
  },
  CAMERA_CONFIG_UPDATE: { value: 'camera_config_update' },
  FIRMWARE_UPDATED: { value: 'firmware_updated', route: device => `event.update.firmware.${device}` },
  APPFEATURE_UPDATED: { value: 'appfeature_updated' },
  SUBSCRIPTION_UPDATED: { value: 'subscription_updated' },
  CHIME_CREATED: { value: 'chime_created', route: 'event.create.chime' },
  CHIME_DELETED: { value: 'chime_deleted', route: 'event.delete.chime' },
  ESCAPE_UNLOCK: { value: 'escape_unlock', route: 'event.operate.escape.unlock' },
  TRANSFER_JOB_PROCESS: { value: 'transfer_job_process', route: 'event.transfer.process' },
  WA_SYSTEM_USER_ADD: { value: 'wa_system_user_add', route: 'event.add.user.wasystem' },
  WA_SYSTEM_USER_REMOVE: { value: 'wa_system_user_remove', route: 'event.delete.user.wasystem' },
  WA_SYSTEM_ACCESSTYPE_CHANGED: { value: 'wa_system_accesstype_changed', route: 'event.update.accesstype.wasystem' },
  WA_SYSTEM_USERTYPE_CHANGED: { value: 'wa_system_usertype_changed', route: 'event.update.usertype.wasystem' },
  WA_SYSTEM_ACTUATOR_STATUS_CHANGED: {
    value: 'wa_system_actuator_status_changed',
    route: 'event.update.status.actuator.wasystem',
  },
  WA_SYSTEM_DEVICE_CONNECTION_STATUS_CHANGED: {
    value: 'wa_system_device_connection_status_changed',
    route: 'event.update.status.connection.device.wasystem',
  },
  WA_SYSTEM_OTA_STATUS_CHANGED: {
    value: 'wa_system_ota_status_changed',
    route: 'event.update.status.ota.wasystem',
  },
  WA_ACCESSORY_FACTORY_RESET: {
    value: 'wa_accessory_factory_reset',
    route: 'event.delete.accessory.wasystem',
  },
  FEATURE_ENABLEMENT: { value: 'feature_enablement', route: featuretype => `event.featureenablement.${featuretype}` },
};

/**
 * Create routes
 * @param { any } events events
 * @returns { object } events Object with routes for event
 */
function getRoutes(events) {
  const result = {};
  for (const key in events) {
    const event = events[key];
    result[event.value] = event.route;
  }

  return result;
}

const Routes = getRoutes(FullEvents);

/**
 * Create enumerables
 * @param { any } events events
 * @returns { object } events Object with enumerable:true set
 */
function getEnumerables(events) {
  const result = {};
  for (const event in events) {
    result[event] = { value: events[event].value, enumerable: true };
  }

  return result;
}

/**
 * Defines events.
 *
 * @enum
 * @readonly
 */
const Events = Object.create(Enum, {
  ...getEnumerables(FullEvents),

  routeRequiresTcpWakeup: {
    value: function(route) {
      return [
        'event.update.settings.doorbell',
        'event.update.buttonpushsetting.doorbell',
        'event.update.chime.settings.doorbell',
        'event.delete.doorbell',
        'event.reboot.doorbell',
        'event.wakeup.doorbell',
        'event.uploadvideo.doorbell',
      ].includes(route);
    },
  },

  toRoute: {
    value: function(event, subroute) {
      subroute = subroute || 'lock';
      const route = Routes[event];

      if (typeof route === 'function') {
        return route(subroute);
      }

      return route || '';
    },
    enumerable: false,
  },
});

/**
 * Defines events associated with
 * Airbnb notifications.
 *
 * @enum
 * @readonly
 */
const AirbnbActions = Object.create(Enum, {
  RESERVATION_ACCEPTED: { value: 'reservation_acceptance_confirmation', enumerable: true },
  RESERVATION_CANCELLED: { value: 'reservation_cancellation_confirmation', enumerable: true },
  RESERVATION_ALTERED: { value: 'reservation_alteration_confirmation', enumerable: true },
  RESERVATION_ALTERATION_CREATED: { value: 'reservation_alteration_created', enumerable: true },
  RESERVATION_ALTERATION_VOIDED: { value: 'reservation_alteration_voided', enumerable: true },
  MESSAGE_ADDED: { value: 'message_added', enumerable: true },
  LISTING_EDITED: { value: 'listing_edited', enumerable: true },
  AUTHORIZATION_REVOKED: { value: 'authorization_revoked', enumerable: true },
});

/**
 * Defines events related to Recurly webhook notifications
 *
 * @enum
 * @readonly
 */
const RecurlyNotifications = Object.create(Enum, {
  NEW_ACCOUNT: { value: 'newAccountNotification', enumerable: true },
  CANCELED_ACCOUNT: { value: 'canceledAccountNotification', enumerable: true },
  BILLING_INFO_UPDATED: { value: 'billingInfoUpdatedNotification', enumerable: true },
  REACTIVATED_ACCOUNT: { value: 'reactivatedAccountNotification', enumerable: true },

  NEW_INVOICE: { value: 'newInvoiceNotification', enumerable: true },
  PROCESSING_INVOICE: { value: 'processingInvoiceNotification', enumerable: true },
  CLOSED_INVOICE: { value: 'closedInvoiceNotification', enumerable: true },
  PAST_DUE_INVOICE: { value: 'pastDueInvoiceNotification', enumerable: true },

  NEW_SUBSCRIPTION: { value: 'newSubscriptionNotification', enumerable: true },
  UPDATED_SUBSCRIPTION: { value: 'updatedSubscriptionNotification', enumerable: true },
  CANCELED_SUBSCRIPTION: { value: 'canceledSubscriptionNotification', enumerable: true },
  EXPIRED_SUBSCRIPTION: { value: 'expiredSubscriptionNotification', enumerable: true },
  RENEWED_SUBSCRIPTION: { value: 'renewedSubscriptionNotification', enumerable: true },

  SCHEDULED_PAYMENT: { value: 'scheduledPaymentNotification', enumerable: true },
  PROCESSING_PAYMENT: { value: 'processingPaymentNotification', enumerable: true },
  SUCCESSFUL_PAYMENT: { value: 'successfulPaymentNotification', enumerable: true },
  FAILED_PAYMENT: { value: 'failedPaymentNotification', enumerable: true },
  SUCCESSFUL_REFUND: { value: 'successfulRefundNotification', enumerable: true },
  VOID_PAYMENT: { value: 'voidPaymentNotification', enumerable: true },

  NEW_DUNNING_EVENT: { value: 'newDunningEventNotification', enumerable: true },

  toRoute: {
    value: function(event) {
      switch (event) {
        case this.NEW_SUBSCRIPTION:
          return 'event.new.subscription.recurly';

        case this.RENEWED_SUBSCRIPTION:
          return 'event.renew.subscription.recurly';

        case this.CANCELED_SUBSCRIPTION:
          return 'event.cancel.subscription.recurly';

        case this.EXPIRED_SUBSCRIPTION:
          return 'event.expire.subscription.recurly';

        case this.UPDATED_SUBSCRIPTION:
          return 'event.update.subscription.recurly';

        case this.CANCELED_ACCOUNT:
          return 'event.cancel.account.recurly';

        default:
          return '';
      }
    },
  },
});

/**
 * Defines events related to Zuora webhook notifications
 *
 * @enum
 * @readonly
 */
const ZuoraNotifications = Object.create(Enum, {
  UPDATED_CATALOG: { value: 'updatedCatalogNotification', enumerable: true },

  toRoute: {
    value: function(event) {
      switch (event) {
        case this.UPDATED_CATALOG:
          return 'event.update.catalog.zuora';
        default:
          return '';
      }
    },
  },
});

/**
 * Defines events related to Mailgun webhook notifications.
 * https://documentation.mailgun.com/api-events.html#event-types
 *
 * @enum
 * @readonly
 */
const MailgunEvents = Object.create(Enum, {
  ACCEPTED: { value: 'accepted', enumerable: true },
  REJECTED: { value: 'rejected', enumerable: true },
  DELIVERED: { value: 'delivered', enumerable: true },
  FAILED: { value: 'failed', enumerable: true },
  OPENED: { value: 'opened', enumerable: true },
  CLICKED: { value: 'clicked', enumerable: true },
  UNSUBSCRIBED: { value: 'unsubscribed', enumerable: true },
  COMPLAINED: { value: 'complained', enumerable: true },
  STORED: { value: 'stored', enumerable: true },
});

/**
 * Defines event sources.
 *
 * @enum
 * @readonly
 */
const EventSources = Object.create(Enum, {
  SYSTEM: { value: 'system', enumerable: true },
  EXTERNAL_SERVICE: { value: 'external_service', enumerable: true },
  DEVICE: { value: 'device', enumerable: true },
  OPERATION: { value: 'operation', enumerable: true },
  PARTNER: { value: 'partner', enumerable: true },
  OAUTH: { value: 'oauth', enumerable: true },
});

/**
 * External services that are event sources
 *
 * @enum
 * @readonly
 */
const ExternalServices = Object.create(Enum, {
  AIRBNB: { value: 'Airbnb', enumerable: true },
  AWS_ELASTIC_TRANSCODER: { value: 'AWS_Elastic_Transcoder', enumerable: true },
  MAILGUN: { value: 'Mailgun', enumerable: true },
  RECURLY: { value: 'Recurly', enumerable: true },
  TWILIO: { value: 'Twilio', enumerable: true },
  ZUORA: { value: 'Zuora', enumerable: true },
});

/**
 * Defines event categories.
 *
 * @enum
 * @readonly
 */
const EventCategories = Object.create(Enum, {
  SYSTEM: { value: 'system', enumerable: true },
  SECURITY: { value: 'security', enumerable: true },
  OPERATION: { value: 'operation', enumerable: true },
  AUTHORIZATION: { value: 'authorization', enumerable: true },
});

exports.Events = Events;
exports.EventSources = EventSources;
exports.EventCategories = EventCategories;
exports.AirbnbActions = AirbnbActions;
exports.RecurlyNotifications = RecurlyNotifications;
exports.ZuoraNotifications = ZuoraNotifications;
exports.MailgunEvents = MailgunEvents;
exports.ExternalServices = ExternalServices;
